import { css } from "@emotion/react";

export const useStyles = (props) => ({
    whiteContentBar: css({
        backgroundColor: "#ffffff",
        height: "40px",
        borderBottom: "1px solid #f5f5f5",
        padding: "10px 15px 10px 15px",
    }),
    leftContent: css({
        fontSize: "12px",
        color: "#abadb1",
        marginTop: "2px",
        textAlign: "left",
        textTransform: "none",
    }),
    rightContent: css({
        fontSize: "12px",
        color: "black",
        marginTop: "2px",
        textAlign: "right",
        textTransform: "none",
    }),
    rightIcon: css({
        fontSize: "18px",
        float: "right",
        width: "18px !important",
        height: "18px !important",
    }),
});
